import { useContext, useEffect } from "react";
import * as Scrivito from "scrivito";
import {
  mountLauncher,
  updateLauncher,
  unmountLauncher,
} from "^/features/studiAssist";
import { CookieConsentContext } from "^/Components/CookieConsentContext";

export const StudiAssistChat = Scrivito.connect(({ homepage, page }) => {
  const { optionAllowed } = useContext(CookieConsentContext);
  const consentGranted = optionAllowed("studiassist");

  const config = {
    chatUrl: "https://hs-heilbronn.studi-assist.de/chat/hhn/de",
    language: page?.get("language") || "auto",
    // Boolean defaults to true when never set by an editor.
    showStatusDot: page?.get("showStatusDot") !== false,
    teaserText: page?.get("teaserText") || "",
  };

  // A primitive key so the config effect only re-runs on actual changes.
  const configKey = JSON.stringify(config);

  // Reference-counted mount: only when consent is granted.
  useEffect(() => {
    if (!consentGranted) return;
    mountLauncher();
    return () => unmountLauncher();
  }, [consentGranted]);

  // Apply (and live-update) the configuration.
  useEffect(() => {
    if (!consentGranted) return;
    updateLauncher(config);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configKey, consentGranted]);

  if (!page || !homepage) {
    return null;
  }

  if (!consentGranted) {
    return null;
  }

  if (Scrivito.isInPlaceEditingActive()) {
    return (
      <div className="studiassist-editor-hint">
        StudiAssist chat launcher — shown bottom-right on this page. Configure
        icon, colors and chat URL in the Homepage properties.
      </div>
    );
  }

  return null;
});
